const formatDate = (date_value: string) =>
  new Date(date_value).toLocaleString("en-AU", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

export interface UsagePeriod {
  start_date: string;
  end_date: string;
}

export interface DatePickerProps {
  usagePeriod: UsagePeriod;
  recentSubscriptionsPeriod: Array<UsagePeriod>;
}

export const formatDatePeriod = (period: UsagePeriod) =>
  `${formatDate(period.start_date)} - ${formatDate(period.end_date)}`;
